import React, { useEffect, useCallback, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import PropTypes, { elementType } from 'prop-types';
import _, { identity } from 'underscore';
import { makeStyles } from '@mui/styles';

import {
	Button, Typography
} from '@mui/material';

import DataTableStyled from '../../../components/DataTable/DataTableStyled.js';
import { GetSTTMAlgorithmData } from '../actions/STTMAlgorithmActionsGeneric';
// import ModalDialog from '../../../components/ModalDialog/ModalDialog';

// import {
// 	GetHTMLString
// } from '../actions/STTMAlgorithmActions';

const useStyles = makeStyles((theme) => ({
	root: {},
	content: {
		padding: 0,
	},
	inner: {
		minWidth: 700,
	},
	nameCell: {
		display: 'flex',
		alignItems: 'center',
	},
	avatar: {
		height: 42,
		width: 42,
		marginRight: theme.spacing(1),
	},
	actions: {
		padding: theme.spacing(1),
		justifyContent: 'flex-end',
	},
	primaryButton: {
		color: theme.palette.primary.main
	},
	errorButton: {
		color: theme.palette.error.main
	},
	infoButton: {
		color: theme.palette.info.main
	},
}));

const STTMAlgorithmDatatableGeneric = (props) => {
	const { className, ...rest } = props;
	const userId = useSelector(state => state.session.user.id);
	const role = useSelector(state => state.session.user.role);
	const data = useSelector((state) => state.STTMAlgorithmReducer.data);
	const week = useSelector((state) => state.STTMAlgorithmReducer.week);

	const updateDate = data[0]?.dateuploaded || '';
	const firstDay = week.firstDay || '';
	const lastDay = week.lastDay || '';

	// const htmlString = useSelector((state) => state.STTMAlgorithmReducer.htmlString);

	const classes = useStyles();
	const dispatch = useDispatch();

	const _headerStyles = () => ({
		alignSelf: 'center',
		fontSize: 12,
		backgroundColor: '#1565c0',
		color: '#FFF',
		minWidth: 100,
		fontFamily: 'Roboto',
		padding: '15px 10px 15px 10px'
	});

	const _headRender = (columnMeta, updateDirection) => (
		<th
			// key={1}
			onClick={() => updateDirection(columnMeta.index)}
			style={_headerStyles()}
		>
			{columnMeta.label}
		</th>
	);

	const _handleStyle = (value) => {
		if (value === 'OK') {
			return {
				style: {
					backgroundColor: 'green',
					color: 'white',
					fontWeight: 'bold'
				}
			};
		} if (value === 'NOK') {
			return {
				style: {
					backgroundColor: '#dc143c',
					color: 'white',
					fontWeight: 'bold'
				}
			};
		} if (value !== 'OK' || value !== 'NOK') {
			return {
				style: {
					backgroundColor: 'yellow',
					color: 'black',
					fontWeight: 'bold'
				}
			};
		}
		return {
		};
	};

	const _generalColumnOptions = () => ({
		display: true,
		filterType: 'textField',
		customHeadRender: (columnMeta, updateDirection) => _headRender(columnMeta, updateDirection),
	});

	const _statusColumnOptions = () => ({
		display: true,
		filterType: 'textField',
		customHeadRender: (columnMeta, updateDirection) => _headRender(columnMeta, updateDirection),
		setCellProps: (value) => (_handleStyle(value))
	});

	// const [open, setOpen] = React.useState(false);
	// const handleOpen = (id, cell) => {
	// 	dispatch(GetHTMLString(id, cell, userId));
	// 	setOpen(true);
	// };
	// const handleClose = () => {
	// 	setOpen(false);
	// };

	const openInNewTab = (url) => {
		window.open(url, '_blank', 'noreferrer');
	};

	const renderDate = (dataIndex) => {
		const completeDate = data[dataIndex].date_kpi;
		return (completeDate.substring(0, 10));
	};

	const renderActions = (dataIndex) => {
		const path = data[dataIndex].reportPath;
		const val = path !== null ? `${data[dataIndex].cell}_report` : '';

		return (
			<div>
				{path !== null
			&& (
				<Button
					className={classes.generate}
					color="primary"
					// onClick={() => handleOpen(data[dataIndex].id, data[dataIndex].cell)}
					onClick={() => openInNewTab(path)}
					variant="contained"
					size="small"
				>
					{val}
				</Button>
			)}
			</div>
		);
	};

	const _getData = useCallback(() => {
		dispatch(GetSTTMAlgorithmData(userId, role));
	}, []);

	useEffect(() => {
		_getData();
	}, [_getData]);

	const _getTableColumns = () => (
		[
			{
				name: 'localNodeGeneric',
				label: 'Node',
				options: _generalColumnOptions(),
				enablePinning: true,
			},
			{
				name: 'localCellGeneric',
				label: 'Cell',
				options: _generalColumnOptions(),
			},
			{
				name: 'date_kpi',
				label: 'Date KPI',
				// options: _generalColumnOptions(),
				options: {
					display: true,
					filterType: 'textField',
					customHeadRender: (columnMeta, updateDirection) => _headRender(columnMeta, updateDirection),
					customBodyRenderLite: (dataIndex) => renderDate(dataIndex)
				},
			},
			{
				name: 'rRCSetupSuccessRate_STATUS',
				label: 'RRCSetupSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_ACTION',
				label: 'RRCSetupSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_TRIGGER',
				label: 'RRCSetupSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_STATUS',
				label: 'E_RABSetupSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_ACTION',
				label: 'E_RABSetupSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_TRIGGER',
				label: 'E_RABSetupSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'serviceDropRate_STATUS',
				label: 'ServDropRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'serviceDropRate_ACTION',
				label: 'ServDropRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'serviceDropRate_TRIGGER',
				label: 'ServDropRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'cellDownlinkAverageThroughput_STATUS',
				label: 'CellDLAvgTP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'cellDownlinkAverageThroughput_ACTION',
				label: 'CellDLAvgTP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'cellDownlinkAverageThroughput_TRIGGER',
				label: 'CellDLAvgTP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'cellUplinkAverageThroughput_STATUS',
				label: 'CellULAvgTP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'cellUplinkAverageThroughput_ACTION',
				label: 'CellULAvgTP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'cellUplinkAverageThroughput_TRIGGER',
				label: 'CellULAvgTP_TRIGGER',
				options: _generalColumnOptions(),
			},
			// NOVOS
			{
				name: 'rRCSetupSuccessRate_Service_STATUS',
				label: 'RRCSetupSuccRate_Serv_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_Service_ACTION',
				label: 'RRCSetupSuccRate_Serv_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_Service_TRIGGER',
				label: 'RRCSetupSuccRate_Serv_TRIGGER',
				options: _generalColumnOptions(),
			},

			{
				name: 'rRCSetupSuccessRate_signaling_STATUS',
				label: 'RRCSetupSuccRate_signal_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_signaling_ACTION',
				label: 'RRCSetupSuccRate_signal_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'rRCSetupSuccessRate_signaling_TRIGGER',
				label: 'RRCSetupSuccRate_signal_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 's1SIGConnectionSetupSuccessRate_STATUS',
				label: 'S1SIGConnSetupSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 's1SIGConnectionSetupSuccessRate_ACTION',
				label: 'S1SIGConnSetupSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 's1SIGConnectionSetupSuccessRate_TRIGGER',
				label: 'S1SIGConnSetupSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_VoIP_STATUS',
				label: 'E_RABSetupSuccRate_VoIP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_VoIP_ACTION',
				label: 'E_RABSetupSuccRate_VoIP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'e_RABSetupSuccessRate_VoIP_TRIGGER',
				label: 'E_RABSetupSuccRatE_VoIP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'callSetupSuccessRate_STATUS',
				label: 'CallSetupSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'callSetupSuccessRate_ACTION',
				label: 'CallSetupSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'callSetupSuccessRate_TRIGGER',
				label: 'CallSetupSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_STATUS',
				label: 'Intra_FreqHOOutSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_ACTION',
				label: 'Intra_FreqHOOutSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_TRIGGER',
				label: 'Intra_FreqHOOutSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_VoIP_STATUS',
				label: 'Intra_FreqHOOutSuccRate_VoIP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_VoIP_ACTION',
				label: 'Intra_FreqHOOutSuccRate_VoIP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_frequencyHandoverOutSuccessRate_VoIP_TRIGGER',
				label: 'Intra_FreqHOOutSuccRate_VoIP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_STATUS',
				label: 'Inter_FreqHOOutSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_ACTION',
				label: 'Inter_FreqHOOutSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_TRIGGER',
				label: 'Inter_FreqHOOutSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_VoIP_STATUS',
				label: 'Inter_FreqHOOutSuccRate_VoIP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_VoIP_ACTION',
				label: 'Inter_FreqHOOutSuccRate_VoIP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_frequencyHandoverOutSuccessRate_VoIP_TRIGGER',
				label: 'Inter_FreqHOOutSuccRate_VoIP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_RATHandoverInSuccessRate_STATUS',
				label: 'Intra_RAT_HOInSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'intra_RATHandoverInSuccessRate_ACTION',
				label: 'Intra_RAT_HOInSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'intra_RATHandoverInSuccessRate_TRIGGER',
				label: 'Intra_RAT_HOInSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_RATHandoverOutSuccessRate_LTEtoWCDMA_STATUS',
				label: 'Inter_RAT_HOOutSuccRate_LTEtoWCDMA_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'inter_RATHandoverOutSuccessRate_LTEtoWCDMA_ACTION',
				label: 'Inter_RAT_HOOutSuccRate_LTEtoWCDMA_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'inter_RATHandoverOutSuccessRate_LTEtoWCDMA_TRIGGER',
				label: 'Inter_RAT_HOOutSuccRate_LTEtoWCDMA_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'cSFBPreparationSuccessRate_STATUS',
				label: 'CSFBPrepSuccRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'cSFBPreparationSuccessRate_ACTION',
				label: 'CSFBPrepSuccRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'cSFBPreparationSuccessRate_TRIGGER',
				label: 'CSFBPrepSuccRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'userDownlinkAverageThroughput_STATUS',
				label: 'UserDLAvgTP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'userDownlinkAverageThroughput_ACTION',
				label: 'UserDLAvgTP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'userDownlinkAverageThroughput_TRIGGER',
				label: 'UserDLAvgTP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'userUplinkAverageThroughput_STATUS',
				label: 'UserULAvgTP_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'userUplinkAverageThroughput_ACTION',
				label: 'UserULAvgTP_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'userUplinkAverageThroughput_TRIGGER',
				label: 'UserULAvgTP_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'downlinkResourceBlockUtilizingRate_STATUS',
				label: 'DLResourceBlockUtilRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'downlinkResourceBlockUtilizingRate_ACTION',
				label: 'DLResourceBlockUtilRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'downlinkResourceBlockUtilizingRate_TRIGGER',
				label: 'DLResourceBlockUtilRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'uplinkResourceBlockUtilizingRate_STATUS',
				label: 'ULResourceBlockUtilRate_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'uplinkResourceBlockUtilizingRate_ACTION',
				label: 'ULResourceBlockUtilRate_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'uplinkResourceBlockUtilizingRate_TRIGGER',
				label: 'ULResourceBlockUtilRate_TRIGGER',
				options: _generalColumnOptions(),
			},
			{
				name: 'averageCQI_STATUS',
				label: 'AvgCQI_STATUS',
				options: _statusColumnOptions(),
			},
			{
				name: 'averageCQI_ACTION',
				label: 'AvgCQI_ACTION',
				options: _generalColumnOptions(),
			},
			{
				name: 'averageCQI_TRIGGER',
				label: 'AvgCQI_TRIGGER',
				options: _generalColumnOptions(),
			},
			//
			{
				name: 'attempt_Hourly_4G',
				label: '4G_Attempt_Hourly',
				options: _generalColumnOptions(),
			},
			{
				name: 'avail_Hourly_Power_Saving_4G',
				label: '4G_Avail_Hourly_Power_Saving',
				options: _generalColumnOptions(),
			},
			{
				name: 'unavailability_Hourly_4G',
				label: '4G_Unavailability_Hourly',
				options: _generalColumnOptions(),
			},
			// {
			// 	name: 'reportPath',
			// 	label: 'Report Path',
			// 	options: {
			// 		display: true,
			// 		customHeadRender: (columnMeta, updateDirection) => _headRender(columnMeta, updateDirection),
			// 		customBodyRenderLite: (dataIndex) => renderActions(dataIndex)
			// 	},
			// },
		]
	);

	const _getTableOptions = () => ({
		filterType: 'dropdown',
		selectableRows: false,
		expandableRows: false,
		fixedHeader: true,
		fixedSelectColumn: true,
	});

	return (
		<div {...rest} className={clsx(classes.root, className)}>
			<div>
				<Typography sx={{ lineHeight: 3 }}>
					Update Date:&nbsp;
					{updateDate.substring(0, 10)}
							 &nbsp;/ KPI Dates:&nbsp;
					{firstDay.substring(0, 10)}
							 &nbsp;to&nbsp;
					{lastDay.substring(0, 10)}
				</Typography>
			</div>
			<DataTableStyled
				enablePinning
				initialState={{ pinnedColumns: { left: ['siteId'] } }}
				id=""
				title=""
				data={data}
				columns={_getTableColumns()}
				rowsPerPage={15}
				tableBodyMaxHeight="30em"
				tableBodyCellMaxWidth="250"
				options={_getTableOptions()}
			/>
			{/* <ModalDialog
				open={open}
				onClose={handleClose}
				maxWidth="90%"
				hasConfirm={false}
			>
				<div dangerouslySetInnerHTML={{ __html: htmlString }} />
			</ModalDialog> */}
		</div>
	);
};

STTMAlgorithmDatatableGeneric.propTypes = {
	className: PropTypes.string,
	data: PropTypes.array.isRequired,
};

export default STTMAlgorithmDatatableGeneric;
